import React from 'react'

import { Button } from '@src/quince-components/src'
import ButtonContentful from '@src/quince-site-common/src/domains/Button'

import { makeButtonProps } from './newLongFormModuleCTA.helpers'
import * as styles from './newLongFormModuleCTA.module.scss'

interface NewLongFormModuleButtonProps {
  button: ButtonContentful
}
const NewLongFormModuleButton = ({ button }: NewLongFormModuleButtonProps) => {
  const buttonProps = makeButtonProps(button)
  if (!buttonProps) {
    return null
  }
  return <Button classNames={[styles.btnLongForm]} {...buttonProps} />
}
export default NewLongFormModuleButton
